<template>
  <div id="app">
    <NavbarMain v-if="!styleStore.loading && $route.path !== '/'" />
    <div class="container mb-5 pb-5 mt-5">
      <!-- <VoucherWizard /> -->
      <router-view />
    </div>
    <FooterMain v-if="!styleStore.loading && $route.path !== '/'" />
  </div>
</template>

<script>
import NavbarMain from "./components/Navbar.vue";
import FooterMain from "./components/FooterMain.vue";
import { useStyleStore } from "./stores/styleStore";
import { useFormStore } from "./stores/formStore";

export default {
  name: "App",
  components: {
    NavbarMain,
    FooterMain,
  },
  data() {
    return {
      styleStore: useStyleStore(),
      formStore: useFormStore(),
    };
  },
  async mounted() {
    await this.$router.isReady();

    let storeId = this.$route.params.storeId;
    if (storeId && storeId !== 'undefined') {
      this.formStore.formData.clientReference = storeId;

      await this.styleStore.fetchStyleConfig(storeId, this.$router);

      document.documentElement.style.setProperty(
        "--prmary-color",
        this.styleStore.primaryColor
      );
      document.documentElement.style.setProperty(
        "--secondary-color",
        this.styleStore.secondaryColor
      );

      // ✅ Set title if store name is available
      if (this.styleStore.storeInfo?.name) {
       document.title = `${this.styleStore.storeInfo.name} | CBE Voucher`;
      }
    }

    // ✅ Watch for name updates in case it loads later
    this.$watch(
      () => this.styleStore.storeInfo?.name,
      (newName) => {
        if (newName) {
          document.title = newName;
        }
      }
    );
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  animation: fadeInAnimation 0.25s ease;
}
@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.btn {
  border-radius: 25px !important;
  padding: 5px 15px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}
.btn-primary {
  background-color: var(--prmary-color) !important;
  border-color: var(--secondary-color) !important;
}
.btn-primary:hover {
  background-color: color-mix(
    in srgb,
    var(--prmary-color) 90%,
    #000
  ) !important;
  border-color: color-mix(in srgb, var(--secondary-color) 90%, #000) !important;
}
.flatpickr-ok-button, .flatpickr-day.selected, .form-check-input:checked {
  background-color: var(--prmary-color) !important;
  border-color: var(--prmary-color) !important;
}

</style>
